<template>
  <div class="home vh-100">
    <swiper :loop="true" :loopedSlides="1" :slidesPerView="auto" :modules="modules" class="mySwiper" :effect="'fade'" :grabCursor="false"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
      }"
      :speed="3000"
      :centeredSlides="true" >

      <swiper-slide >
        <div class="h-100">
          <div class="Image-wrapper">
            <img src="../assets/img/banner.jpg" class="slide-img" />
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="Banner-content">
      <!-- <h2 >
        Nestled in the heart of North West London
      </h2> -->
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, useSwiper } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/effect-fade";

// import required modules
import { EffectFade, Autoplay } from 'swiper';

export default {
  name: 'HomeView',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [EffectFade, Autoplay],
    };
  },
  created(){
    document.title = "Heybourne Park"
    this.PageViewCount();
  },
  data() {
    return {
      imgArr: [
        { url: require(`../assets/img/banner.jpg`) },
      ]
    };
  },
  methods: {
    PageViewCount(){
      if(sessionStorage.getItem('session_id') != null){
          let data = { 
              session_id: sessionStorage.getItem('session_id'),
              page_name: "Home"
          }
          fetch(this.base_url+'AddPageView',{
              method: 'POST', // or 'PUT'
              headers: {
                  
              },
              body: JSON.stringify(data),
              })
          .then(response => response.json())
          .then(res => {
              
          });
      }
    }
  }
}
</script>

<style scoped lang="scss">
* {
  //font-family: "Mitreba-regular";
}

.home {
  .swiper {
    width: 100%;
    height: 100%;
    
    overflow: hidden;
  }

  img {
    height: 100%;
  }
 
}

.slide-img{
  position: absolute;
  width:100%;
  object-fit: cover;
}

.Banner-content {
  position: absolute;
  top: 50px;
  color: #fff;
  line-height: 80px;
  z-index: 3;
  width: 100%;
  text-align: center;
  
  h2 {
    font-size: 80px !important;
    text-transform:uppercase;
    font-weight:500;
    letter-spacing: 10px;
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .home {
    .swiper {
      width: 100%;
      height: 100%;
    }
  }

  .Banner-content {
    position: absolute;
    color: #fff;
    padding: 20px;
    z-index: 3 !important;
    left: 0;
    top: 100px;
    h2 {
      font-size: 22px !important;
      //font-family: "aeonik-bold";
    }
  } 
}

@media screen and (max-width: 2400px)  {
  .home .lines div:first-child {
    margin-left: 15px;
  }
}

@media screen and (max-width: 1920px)  {
  .home .lines div:first-child {
    margin-left: 17px;
  }
}

@media screen and (min-width: 1081px)  {
  
  .Banner-content {
    h2 {
      font-size: 50px !important;
    }
  } 
}

@media screen and (max-width: 1080px)  {
  .home .lines div:first-child {
    margin-left: 27px;
  }

  .Banner-content {
    h2 {
      //font-family: "aeonik-bold";
    }
  } 
}

@media screen and (max-width: 768px) and (orientation: landscape) {
  .home .lines div:first-child {
    margin-left: 0px;
  }

  .lines div:nth-child(n+3) {
    display: none !important;
  }

  .Image-wrapper {
    display: flex;
    align-items: last baseline;
    justify-content: stretch;
    width: 100%;
    height: 100%;
  }

  .slide-img{
    position: absolute;
    width:auto !important
  }

}


@media screen and (max-width: 768px) and (orientation: portrait) {
  .home .lines div:first-child {
    margin-left: 13px;
  }

  .Image-wrapper {
    display: flex;
    align-items: last baseline;
    justify-content: stretch;
    width: 100%;
    height: 100%;
  }

  .slide-img{
    position: absolute;
    width:100% !important
  }
  
}

</style>